import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { normalizeSort, SORT_MAPPINGS } from '../utils/helpers/sortMapping';
import { setSearchSort } from '../actions';
import { selectSearchFormCurrentSortType } from '../store/selectors';
import { PriceViewMode } from '../components/GeneralAdsPage/types';
import { ItemConnectionSort, SortOption } from '../graphql/types';
import { generateSortingHrefAndAs } from '../utils/helpers/generateSortingHrefAndAs';

type UpdateSortOptions = {
  sortData?: SortOption[];
  mode?: boolean;
  isPashaLanding?: boolean;
};

export function useSorting() {
  const router = useRouter();
  const dispatch = useDispatch();
  const currentSort = useSelector(selectSearchFormCurrentSortType);

  const updateSort = (
    sort: ItemConnectionSort,
    priceMode: PriceViewMode,
    options: UpdateSortOptions = {}
  ) => {
    let nextSort = normalizeSort(priceMode, sort);

    if (options.mode) {
      const mapped = SORT_MAPPINGS[priceMode]?.[sort];

      if (!mapped) return;
      nextSort = mapped;
    }

    dispatch(setSearchSort(nextSort));

    const { search, ...queryObj } = router.query;
    const { href, as } = generateSortingHrefAndAs({
      queryObj,
      search,
      sortValue: nextSort,
      sortData: options.sortData,
      pathname: router.pathname
    });

    router.push(href, as, {
      scroll: false,
      shallow: !!options.isPashaLanding
    });
  };

  return { currentSort, updateSort };
}
